import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'rdf-form-main-properties',
  templateUrl: './form-main-properties.component.html',
  styleUrls: ['./form-main-properties.component.css']
})
export class FormMainPropertiesComponent implements OnInit {
  @Input() stage;
  constructor() { }

  ngOnInit() {
  }

}
